import { useMemo } from 'react'

import { invoiceLanguageToLocale } from '@features/invoices/constants/invoiceLanguageToLocale'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import { useDefaultTradeName } from '../../../hooks/useDefaultTradeName'
import { useGetZervantDocumentSettings } from '../../../hooks/useGetZervantDocumentSettings'
import { getDocumentDefaultsFormValues } from '../../../utils/getDocumentDefaultsFormValues'
import type { PresetsSettingsFormValues } from '../types/presetsSettingsFormValues'

export const usePredefinedPresetsSettingsFormValues = () => {
  const { defaultTradeName, hasFailedToLoad, isLoading: isLoadingTradeName, refetch } = useDefaultTradeName()
  const { getDefaultSettingsValue, isLoading: isLoadingDocumentSettings } = useGetZervantDocumentSettings(
    InvoiceDocumentType.Invoice,
  )

  const isLoading = isLoadingTradeName || isLoadingDocumentSettings

  const predefinedPresetsSettingsFormValues: Partial<PresetsSettingsFormValues> = useMemo(() => {
    const defaultContact = defaultTradeName?.contact
    const { currency, language, productType } = getDocumentDefaultsFormValues(getDefaultSettingsValue)

    return {
      contactEmail: defaultContact?.email,
      contactFirstName: defaultContact?.name?.first,
      contactLastName: defaultContact?.name?.last,
      contactPhone: defaultContact?.phone,
      currency,
      language: invoiceLanguageToLocale[language],
      productType,
    }
  }, [defaultTradeName, getDefaultSettingsValue])

  return { hasFailedToLoad, isLoading, predefinedPresetsSettingsFormValues, refetch }
}
